import React, { useState } from 'react';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { ACTIVITY_CALENDAR_CARD_TABS } from '../../../../constants/ActivityCalendarConst';
import ActivityCalendarCetails from './activity-calendar-details';

const ActivityCalendarView = ({ activityData, handleBack, handleEdit, getAlllocationData }) => {
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const renderScreen = () => {
    return (
      <ActivityCalendarCetails
        tabValue={tabValue}
        activityData={activityData}
        getAlllocationData={getAlllocationData}
      />
    );
  };

  return (
    <DetailViewLayout
      onClickEdit={() => handleEdit(activityData)}
      handleTabChange={handleTabChange}
      tabValue={tabValue}
      tabList={ACTIVITY_CALENDAR_CARD_TABS}
      renderScreen={renderScreen}
      onViewToggle={handleBack}
      createdUserId={''}
      isEditable={true}
      isHeightIncluded={true}
      title={activityData?.name}
      tabClass='col-md-10'
    />
  );
};

export default ActivityCalendarView;
